const CONSTANTS = {
    blockTimeSeconds: 14,
    maxOwnedTulipsBatchSize: 60,
    myTulipsPaginationFetchMoreDistanceThreshold: 512,
};

export default CONSTANTS;